import { isQuotingToolAvailable } from 'modules/common/permissions';

import { initPurchasedComponentsPage } from './data/sagas';
import PurchasedComponentsListPage from './entry';

export default [
  {
    exact: true,
    path: '/processes/components',
    component: PurchasedComponentsListPage,
    saga: initPurchasedComponentsPage,
    permissions: [isQuotingToolAvailable],
  },
];
